import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-time-widget',
  templateUrl: './time-widget.component.html',
  styleUrls: ['./time-widget.component.scss']
})
export class TimeWidgetComponent {
  @Input() dates: { text: string, value: number }[] = [];
  @Output() handleSubmitResponse = new EventEmitter();
  timeArray: string[] = [];
  selectedTimeIndex = 0;
  period: 'AM' | 'PM' = 'AM';
  isError = false;
  
  @Input() canChangeStyle: any;
  DATA: any;
  styleSheet: CSSStyleSheet | undefined;
  @Input() clientConfigurationData: any;

  @ViewChild('timeRef')
  timeRef!: ElementRef;

  ngOnInit() {

    this.timeArray = this.dates.map(date => date.text);
  

    
    if (this.canChangeStyle) {
      this.DATA = this.clientConfigurationData;
      this.fnSetStyles();
    } else {
      this.fnSetDefaultStyles();
    }
  }

  ngAfterViewInit() {
    // Ensure that the initial selection is centered
    this.scrollToSelected();
  }

  startDrag(event: any) {
    // Handle drag start
    event.preventDefault();
  }

  endDrag() {
    // Handle drag end
  }

  onScroll() {
    const container = this.timeRef.nativeElement;
    const scrollTop = container.scrollTop;
    const itemHeight = container.children[1].clientHeight; // Height of each time item (adjust accordingly)
    const newIndex = Math.round(scrollTop / itemHeight);

    if (newIndex >= 0 && newIndex < this.timeArray.length) {
      this.selectedTimeIndex = newIndex;
    }
  }

  scrollToSelected() {
    const container = this.timeRef.nativeElement;
    const itemHeight = container.children[1].clientHeight; // Height of each time item
    const offset = this.selectedTimeIndex * itemHeight;
    container.scrollTop = offset;
  }

  setPeriod(newPeriod: 'AM' | 'PM') {
    this.period = newPeriod;
  }

  submitTime() {
    const selectedTime = `${this.timeArray[this.selectedTimeIndex]}`;
    console.log('Selected Time:', selectedTime);

    // Validate the selected time (example)
    if (this.timeArray.includes(this.timeArray[this.selectedTimeIndex])) {
      this.isError = false;
      // Proceed with further logic (e.g., save, send to server)
    } else {
      this.isError = true;
    }

    this.handleSubmitResponse.emit(selectedTime);
  }

  scrollUp() {
    if (this.selectedTimeIndex > 0) {
      this.selectedTimeIndex--;
      this.scrollToSelected(); // Scroll to the new selected item
    }
  }

  scrollDown() {
    if (this.selectedTimeIndex < this.timeArray.length - 1) {
      this.selectedTimeIndex++;
      this.scrollToSelected(); // Scroll to the new selected item
    }
  }

  fnSetStyles() {
    let style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    this.styleSheet = style.sheet as CSSStyleSheet;

    this.styleSheet.insertRule(`.title {
      background: `+ this.DATA.PrimaryColor + ` !important;	
    }`);

    this.styleSheet.insertRule(`.submit-container-button {
      background: `+ this.DATA.PrimaryColor + ` !important;	
    }`);

    // .scroll-button-left, .scroll-button-right

    this.styleSheet.insertRule(`.scroll-button-left {
      background: `+ this.DATA.PrimaryColor + ` !important;	
    }`);

    this.styleSheet.insertRule(`.scroll-button-right {
      background: `+ this.DATA.PrimaryColor + ` !important;	
    }`);



  }

  fnSetDefaultStyles() {
    let style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    this.styleSheet = style.sheet as CSSStyleSheet;
    this.styleSheet.insertRule(`.title {
      background: `+ '#156087' + ` !important;	
    }`);

    this.styleSheet.insertRule(`.submit-container-button {
      background: `+ '#156087' + ` !important;	
    }`);

    this.styleSheet.insertRule(`.scroll-button-left {
      background: `+ '#156087' + ` !important;	
    }`);

    this.styleSheet.insertRule(`.scroll-button-right {
      background: `+ '#156087' + ` !important;
    }`);
  }
}
